/** Общата календарна аритметика използва една и съща часова зона във всички форми. */
export function eventDayKey(date: Date): string {
    const parts = new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Sofia", year: "numeric", month: "2-digit", day: "2-digit",
    }).formatToParts(date);
    const part = (name: string): string => parts.find(value => value.type === name)?.value || "";
    return `${part("year")}-${part("month")}-${part("day")}`;
}

export function isWithinEventPeriod(start: Date, first?: Date | null, last?: Date | null): boolean {
    if (!first || !Number.isFinite(first.getTime()) || !Number.isFinite(start.getTime())) return false;
    const day = eventDayKey(start);
    return day >= eventDayKey(first) && day <= eventDayKey(last || first);
}

export function eventDateLabel(date: Date): string {
    return eventDayKey(date).split("-").reverse().join(".");
}

export function eventTimeLabel(date: Date): string {
    return new Intl.DateTimeFormat("en-GB", {
        timeZone: "Europe/Sofia", hour: "2-digit", minute: "2-digit", hourCycle: "h23",
    }).format(date);
}

export function eventPeriodError(start: Date, name: string, first?: Date | null, last?: Date | null): string | null {
    if (isWithinEventPeriod(start, first, last)) return null;
    const period = first ? `${eventDateLabel(first)}${last ? ` – ${eventDateLabel(last)}` : ""}` : "липсва валиден период";
    return `Не може да се планира работа на ${eventDateLabel(start)} за „${name}“. Период на събитието: ${period}. Коригирайте датата или периода на събитието.`;
}
